import React from 'react';
import Icon from '../../../components/AppIcon';
import JobCard from './JobCard';

const KanbanColumn = ({ 
  column, 
  jobs, 
  onDrop, 
  onDragOver, 
  onDragStart, 
  onContextMenu 
}) => {
  const getColumnIcon = (status) => {
    const icons = {
      'new': 'Plus',
      'assigned': 'UserCheck',
      'in-progress': 'Loader2',
      'awaiting-invoice': 'FileText',
      'completed': 'CheckCircle'
    };
    return icons?.[status] || 'Circle';
  };

  const getColumnColor = (status) => {
    const colors = {
      'new': 'var(--color-accent)',
      'assigned': 'var(--color-warning)',
      'in-progress': 'var(--color-accent)',
      'awaiting-invoice': 'var(--color-warning)',
      'completed': 'var(--color-success)'
    };
    return colors?.[status] || 'var(--color-muted-foreground)';
  };

  return (
    <div className="flex-1 min-w-[280px] md:min-w-[320px] lg:min-w-[360px]">
      <div className="bg-surface rounded-lg border border-border h-full flex flex-col">
        <div className="p-4 border-b border-border">
          <div className="flex items-center justify-between mb-2">
            <div className="flex items-center gap-2">
              <div 
                className="h-8 w-8 rounded-lg flex items-center justify-center"
                style={{ backgroundColor: `${getColumnColor(column?.id)}20` }}
              >
                <Icon name={getColumnIcon(column?.id)} size={18} color={getColumnColor(column?.id)} />
              </div>
              <h3 className="text-base md:text-lg font-semibold text-foreground font-heading">{column?.title}</h3>
            </div>
            <div 
              className="h-6 w-6 rounded flex items-center justify-center"
              style={{ backgroundColor: `${getColumnColor(column?.id)}20` }}
            >
              <span className="text-xs font-semibold font-data" style={{ color: getColumnColor(column?.id) }}>
                {jobs?.length}
              </span>
            </div>
          </div>
          <p className="text-xs text-muted-foreground font-caption">{column?.description}</p>
        </div>

        <div
          onDrop={(e) => onDrop(e, column?.id)}
          onDragOver={onDragOver}
          className="flex-1 p-4 overflow-y-auto min-h-[400px] md:min-h-[500px] lg:min-h-[600px]"
        >
          {jobs?.length === 0 ? (
            <div className="flex flex-col items-center justify-center h-full text-center p-4 md:p-6 lg:p-8">
              <div 
                className="h-12 w-12 md:h-16 md:w-16 rounded-lg flex items-center justify-center mb-3"
                style={{ backgroundColor: `${getColumnColor(column?.id)}10` }}
              >
                <Icon name={getColumnIcon(column?.id)} size={24} color={getColumnColor(column?.id)} />
              </div>
              <p className="text-sm text-muted-foreground font-caption">No jobs in {column?.title?.toLowerCase()}</p>
            </div>
          ) : (
            jobs?.map(job => (
              <JobCard
                key={job?.id}
                job={job}
                onDragStart={onDragStart}
                onContextMenu={onContextMenu}
              />
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default KanbanColumn;